<template>
<div class="pagewide promocodes mtpage">

	<topheader back="/panel">
		<template v-slot:info>
			<span>{{$t('plans.promoCaptions')}}</span>
		</template>
		<template v-slot:right>
			
		</template>

	</topheader>

	<maincontent>
		<template v-slot:content>
            <promocodes />
		</template>
	</maincontent>


</div>
</template>

<style lang="sass" scoped>
	

</style>

<script>

import promocodes from "@/components/modules/panel/promocodes/index.vue"


export default {
	name: 'panel_promocodes_page',
	components: {
		promocodes
	},

	data : function(){
		return { 
			searchEnabled : false
		}
	},

	computed: {

	},

	methods: {
		
	},

	mounted() {

	}
}
</script>
